import React from "react";
import { useTranslation } from "react-i18next";

// Components
import Typography from "../../components/Typography";

// Styles
import styles from "./style.module.scss";

// Images
import SnapshotImage from "images/icons/snapshot.png";


const SnapshotChatTop: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.image_container}>
        <img src={SnapshotImage} alt="Snapshot" className={styles.image} />
      </div>

      <Typography variant="h1" className={styles.title}>
        {t("generate.snapshot.title")}
      </Typography>

      <Typography variant="p" className={styles.subtitle}>
        {t("generate.snapshot.subtitle")}
      </Typography>
    </div>
  )
}

export default SnapshotChatTop
